import { createContext } from 'react';

const ingresoContext = createContext();

export default ingresoContext;